import React from "react";
import { Document, Page, Text, View ,PDFDownloadLink  } from "@react-pdf/renderer";

// // Define styles
export const InvoicePDF = ({ orders }) => {
  return(  <Document>
      <Page style={{ padding: 20 }}>
        {/* Title */}
        <Text
          style={{
            fontSize: 24,
            marginBottom: 20,
            textAlign: "center",
          }}
        >
          Invoice
        </Text>

        {/* Order Details */}
        <View
          style={{
            marginBottom: 10,
          }}
        >
          <Text>Order ID: {orders?.order_id}</Text>
          <Text>
            Order Date:{" "}
            {orders?.created_at
              ? new Date(orders.created_at).toLocaleString("en-US", {
                  day: "2-digit",
                  month: "long",
                  year: "numeric",
                  hour: "numeric",
                  minute: "numeric",
                  hour12: true,
                })
              : ""}
          </Text>
          <Text>{orders?.products?.length || 0} items</Text>
        </View>

        <View
          style={{
            borderStyle: "dashed",
            borderWidth: 1,
            marginVertical: 10,
          }}
        />

        {/* Customer Details */}
        <View
          style={{
            marginBottom: 10,
          }}
        >
          <Text style={{ fontWeight: "bold" }}>Customer Details:</Text>
          <Text>Name: {orders?.user?.full_name || "N/A"}</Text>
          <Text>Email: {orders?.user?.email || "N/A"}</Text>
          <Text>Contact: {orders?.user?.phone || "N/A"}</Text>
          {orders?.user?.delivery_address && (
            <>
              <Text>Shipping Address:</Text>
              <Text>{orders?.user?.delivery_address}</Text>
            </>
          )}
        </View>

        {/* Divider */}
        <View
          style={{ borderStyle: "dashed", borderWidth: 1, marginVertical: 10 }}
        />

        {/* Product Details */}
        <View
          style={{
            marginBottom: 10,
          }}
        >
          <Text style={{ fontWeight: "bold" }}>Product Details:</Text>
          {orders?.products?.map((product, index) => (
            <Text key={index}>
              {product.product_name} - {product.quantity}
            </Text>
          ))}
        </View>

        <View
          style={{
            borderStyle: "dashed",
            borderWidth: 1,
            marginVertical: 10,
          }}
        />
        <View
          style={{
            marginBottom: 10,
          }}
        >
          <Text style={{ fontWeight: "bold" }}>Billing Details:</Text>
          <Text>Item Cost: ₹{orders?.sub_total_item_cost || 0}</Text>
          <Text>Discount: -₹{orders?.sub_total_discount || 0}</Text>
          <Text>Shipping Cost: ₹{orders?.shipping_cost || 0}</Text>
          <Text>Delivery Cost: ₹{orders?.delivery_cost || 0}</Text>
          <Text>Wallet Amount: -₹{orders?.wallet_amount || 0}</Text>
          <Text>Cashback Amount: -₹{orders?.cashback || 0}</Text>
          <Text>Total Amount: ₹{orders?.total || 0}</Text>
          <Text>GST: ₹{Math.floor(orders?.gst || 0)}</Text>
          <Text style={{ marginTop: 10, fontWeight: "bold" }}>
            Total Payment: ₹{orders?.grand_total_cost || 0}
          </Text>
        </View>
      </Page>
    </Document>)
  };
